import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faPlusSquare, faCheck } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { alertFormSubmit, getApi }  from "../../utils/event_handling";
import { userValidation, sortDict } from '../../utils/common_utils';
import {DQ_ALERT_ALLOWED_METRICS, CONFORMITY_METRICS_CUSTOM_ALERTS, IS_NONE_CHECK, triggers} from "../../utils/constant";
import Form from 'react-bootstrap/Form';
import { Formik, ErrorMessage } from 'formik';
import * as yup from 'yup';
import {connect} from "react-redux";
// import _ from 'lodash';
import {MODEL_ALERT_ALLOWED_METRICS} from '../../utils/constant';
import {storeMetadataDetails} from "../../redux/actions";
import {normalizeAttributeName, attributeNameFromMappedValue, normalizeChildDatasetName} from "../../utils/attribute_name_utils";
let expressionData = {alert_metrics_options:"", alert_conditional_op:"", alert_threshold_val:"", alert_join_options:""};

const Expressions = (props) => {
        return props.expressions.map((expression, idx) => {
            let selectedMetricName = props.expressions[idx].alert_metrics_options;
            return (
                <>
                 {
                    (props.expressions.length > 1 && idx !== 0) &&
                    <div className="form-group form-row" id={idx} key={idx}>
                        <div className="col-md-3 col-5 col-select-control__placeholder-sm">
                        <Select
                            name="alert_join_options"
                            filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                            id="join_condition"
                            onChange={(e) => props.dropDownChange(idx, "alert_join_options", e)}
                            value={props.expressions[idx].alert_join_options}
                            options={props.alert_join_options}
                            placeholder="Condition"
                            classNamePrefix='select-control'
                        />
                        {expression !== undefined && expression.alert_join_options ==="" && props.errorMsg === true?
                        <div class="error-text">Condition is required field</div>:''
                        }
                        </div>
                    </div>
                }
                <div className="form-group form-row" id={idx} key={idx}>
                     <div className="col-md-5 col-10">
                        <Select
                            name="alert_metrics_options"
                            filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                            id="selectMetricsAlert"
                            onChange={(e) => props.dropDownChange(idx, "alert_metrics_options", e)}
                            value={props.expressions[idx].alert_metrics_options}
                            options={props.metrics_options}
                            placeholder="Select Metrics"
                            classNamePrefix='select-control'
                        />
                        {expression !== undefined && expression.alert_metrics_options ==="" && props.errorMsg === true?
                        <div class="error-text">Metrics is required field</div>:''
                        }
                    </div>
                    <div className="col-md-3 col-5 col-select-control__placeholder-sm">
                        <Select
                            name="alert_conditional_op"
                            filterOption={({label}, query) => label.includes(query)}
                            id="alertCondition"
                            onChange={(e) => props.dropDownChange(idx, "alert_conditional_op", e)}
                            value={props.expressions[idx].alert_conditional_op}
                            options={props.alert_conditional_op}
                            placeholder="Condition"
                            classNamePrefix='select-control'
                        />
                        {expression !== undefined && expression.alert_conditional_op ==="" && props.errorMsg === true?
                        <div class="error-text">Condition is required field</div>:''
                        }
                    </div>
                    {selectedMetricName !== null && selectedMetricName["label"] !== "Row Count"  && selectedMetricName["is_udfm"] === false?
                        <div className="col-md-3 col-5 col-select-control__placeholder-sm">
                            <Select
                                name="alert_threshold_val"
                                filterOption={({label}, query) => label.includes(query)}
                                id="alertThreshold"
                                onChange={(e) => props.dropDownChange(idx, "alert_threshold_val", e)}
                                value={props.expressions[idx].alert_threshold_val}
                                options={props.alert_threshold_options}
                                placeholder="Threshold"
                                classNamePrefix='select-control'
                            />
                        {expression !== undefined && expression.alert_threshold_val ==="" && props.errorMsg === true?
                        <div class="error-text">Threshold is required field</div>:''
                        }
                    </div>
                     :
                    <div className="col-md-3 col-4 col-select-control__placeholder-sm">
                        <Form.Control
                            type="number"
                            min="0"
                            className="form-control"
                            value={expression.alert_threshold_val ==="" ? expression.alert_threshold_val:props.expressions[idx].alert_threshold_val["value"]}
                            name="alert_threshold_val"
                            placeholder="Threshold"
                            onChange={(e) => props.dropDownChange(idx, "alert_threshold_val", {"value": Math.abs(e.target.value)})}
                                                    />
                        {expression !== undefined && expression.alert_threshold_val ==="" && props.errorMsg === true?
                        <div class="error-text">Threshold is required field</div>:''
                        }
                    </div>
                    }
                    <div className="col-md-1 col-1 col-select-control__placeholder-sm">
                        <button type="button"
                        onClick={props.removeExpression.bind(null,idx)}
                        className="btn btn-outline-primary btn-remove px-3">
                        </button>
                    </div>
                </div>
                </>
            );
        });
}


class AlertForm extends React.Component {

    constructor(props) {
        super(props);
        let alertMechanismValue = [];
        let id = '';
        let pipelineName = localStorage.getItem("pipelineTriggerName");
        if(pipelineName !== undefined && pipelineName !== null) {
            let pipelineTriggerType = localStorage.getItem("pipelineTriggerType");
            let pipelineTriggerId = localStorage.getItem("pipelineTriggerId");
            id = pipelineTriggerId;
            alertMechanismValue.push({"label":pipelineName,"value":"pid_"+Number(pipelineTriggerId),"type":pipelineTriggerType});
         }
        this.getApi = getApi.bind(this);
        this.alertFormSubmit = alertFormSubmit.bind(this);
        this.getAllOptions = this.getAllOptions.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.enableButton = this.enableButton.bind(this);
        this.associateOptions = [];
        this.datasetOptions = [];
        this.state = {
            hideSubmitButton: false,
            model: null,
            dataSource: null,
            dataSet: null,
            attribute: null,
            expressions: [],
            errorMsg:false,
            selectedOptions: [],
            alert_mechanism: id,
            pipelineOptions: [],
            notificationOptions: [],
            exConsume: [],
            exPipeline: [],
            options: [],
            errors: {
            },
            alerts: {
                alert_name: "",
                mechanismOptions: alertMechanismValue,
                alertComputeType: "",
            },
            alertType: triggers.INSTANT_NOTIFICATION,
            alertComputeType: null,
            alertPeriod : triggers.DAY_SCHEDULE,
            alertTypeWithkey: triggers.EMPTY_ALERT,
            alertPeriodWithKey: triggers.EMPTY_PERIOD,
            associatedWithKey: triggers.EMPTY_ASSOCIATED,
            alertDatasetWithKey: triggers.EMPTY_DATASET_WITH_KEY,
            alertAttributeWithKey: triggers.EMPTY_ATTRIBUTE_WITH_KEY,
            alertModelWithKey: triggers.EMPTY_MODEL_WITH_KEY,
            alertDataSourceWithKey: triggers.EMPTY_DATASOURCE_WITH_KEY,
            alertMechanismWithKey: triggers.EMPTY_ALERT_MECHANISM_WITH_KEY,
            isEdit : false
        };
    }
    componentDidMount() {
        this.getApi("trigger");
        this.getApi("completeMetricInfo");
        this.fillDetails();
    }

    componentWillUnmount() {
      localStorage.removeItem("pipelineTriggerName");
      localStorage.removeItem("pipelineTriggerType");
      localStorage.removeItem("pipelineTriggerId");
    }

    fillDetails() {
        let expressions= [];
        //this.associateOptions = this.getAssociations();
        const exAlert = this.props.exDetails;

        if (exAlert === undefined) {
            return;
        }
        let alerts = this.state.alerts;
        let dataSource, model = null;
        if (exAlert.metrics_definition !== undefined && exAlert.metrics_definition.gates !== undefined){
             dataSource = exAlert.metrics_definition.integration;
             model = exAlert.metrics_definition.model;
             if(dataSource !== undefined && dataSource !== null) {
                alerts.dataSourceId = dataSource.value;

             }else if(model !== undefined && model !== null) {
                alerts.modelId = model.value;

             }
             expressions = this.editExpression(exAlert.metrics_definition.gates);
        }
        this.datasetOptions = this.getDatasets(dataSource, model);
        alerts.alert_name = exAlert.alert_name;
        alerts.alertPeriod = exAlert.alert_period;
        let alertType = exAlert.alert_type;
        let alertPeriod = exAlert.alert_period;
        let data_set_id = exAlert.data_set_id;
        let attribute_name = exAlert.metrics_definition.attribute_name;
        let alertComputeType = exAlert.metrics_definition.alert_computation_type;
        let data_set_match = this.datasetOptions.filter(x => Number(x.value) === data_set_id);
        let selectedDataset = {label: "", value: null, type: ""}
        if (data_set_match.length > 0) {
            alerts.dataset = data_set_match[0];
            alerts.data_set_id = data_set_match[0].value;
            selectedDataset.label = data_set_match[0];
            selectedDataset.value = Number(data_set_match[0].value);
            selectedDataset.type = data_set_match[0].type;
        }
        let selectedAttribute = {label: "", value: null}
        if (attribute_name !== undefined && attribute_name!== null){
            let attributes = this.getAttributes(dataSource, selectedDataset);
            let attribute_match = attributes.filter(x => x.value === attribute_name);
            if (attribute_match.length > 0){
                alerts.attribute = attribute_match[0];
                alerts.attribute_name = attribute_match[0].value;
                selectedAttribute.label = attribute_match[0].label;
                selectedAttribute.value = attribute_match[0].value;
            }
        }
        let  selectedComputeType= {label: "", value: null}
        if (alertComputeType !== undefined && alertComputeType!== null){
            let computeOptions = this.getComputationTypes();
            let match_computation = computeOptions.filter(x => x.value === alertComputeType);
            if (match_computation.length > 0){
                alerts.alertComputeType = match_computation[0];
                selectedComputeType.label = match_computation[0].label;
                selectedComputeType.value = match_computation[0].value;
            }
        }

        //let masId = exAlert.mas_id
        //let associationMatch = this.associateOptions.filter(x => x.value === masId);
        //if (associationMatch.length > 0) {
        //    alerts.association = associationMatch[0];
        //}
        let optionList = [];
        let consumeIds = exAlert.consume_group_id;
        let consumeName = exAlert.consume_group_name;
        let pipelineIds = exAlert.pipeline_trigger_id;
        let pipelineName = exAlert.pipeline_trigger_name;
        let consumeType = exAlert.consume_group_type;
        let pipelineType = exAlert.pipeline_trigger_type;

        if(consumeName.length>0) {
            alerts.alertMechanism = consumeIds[0].toString();
            for(let i=0;i<consumeName.length;i++) {
                optionList.push({"label":consumeName[i],"value":"nid_"+consumeIds[i],"type":consumeType[i]})
            }
        }
        if(pipelineName.length>0) {
            alerts.alertMechanism = pipelineIds[0].toString();
            for(let i=0;i<pipelineName.length;i++) {
                optionList.push({"label":pipelineName[i],"value":"pid_"+pipelineIds[i],"type":pipelineType[i]})
            }
        }
        alerts.mechanismOptions = optionList;
        let consumeGroup = [];
        let pipeline = [];
        if (optionList.length>0) {
                for (let i = 0; i < optionList.length; i++) {
                    if(optionList[i]["type"] === "email" || optionList[i]["type"] === "slack") {
                        let alertFormId = optionList[i]["value"]
                        let alertId = alertFormId.split("_")
                        let alertIdData = alertId[1]
                        consumeGroup.push(alertIdData);
                    }
                    else if(optionList[i]["type"] === "webhook" || optionList[i]["type"] === "databricks") {
                        let alertFormId = optionList[i]["value"]
                        let alertId = alertFormId.split("_")
                        let alertIdData = alertId[1]
                        pipeline.push(alertIdData);
                    }
                }
            }
        this.setState({isEdit: true})
        this.setState({exConsume:consumeGroup, dataSource: dataSource, model: model, dataSet:selectedDataset, attribute: selectedAttribute});
        this.setState({exPipeline:pipeline});
        this.setState({alerts});
        this.setState({alertType: alertType});
        this.setState({alertComputeType: selectedComputeType});
        this.setState({alertPeriod: alertPeriod});
        this.setState({expressions: expressions});
        this.setState({alertTypeWithkey: triggers.UPDATED_ALERT});
        this.setState({alertPeriodWithKey: triggers.UPDATED_PERIOD});
        this.setState({associatedWithKey: triggers.UPDATED_ASSOCIATED});
        this.setState({alertScheduleWithkey: triggers.UPDATED_ALERT_SCHEDULE});
        this.setState({alertDatasetWithKey: triggers.UPDATED_DATASET_WITH_KEY});
        this.setState({alertAttributeWithKey: triggers.UPDATED_ATTRIBUTE_WITH_KEY})
        this.setState({alertMechanismWithKey: triggers.UPDATED_ALERT_MECHANISM_WITH_KEY,
                       alertModelWithKey: triggers.UPDATED_MODEL_WITH_KEY,
                       alertDataSourceWithKey: triggers.UPDATED_DATASOURCE_WITH_KEY});
    }


    editExpression(editExpressions){
        let expressions =[];
        let bool_condition = null;
        editExpressions.forEach(element => {
            if(element === 'AND' || element === "OR"){
                bool_condition = element;
            } else {
                let finalDict ={}
                let alert_metrics_options ={};
                let alert_conditional_op ={};
                let alert_threshold_val ={};
                let alert_join_options = {};
                alert_metrics_options["label"] = element[0];
                alert_metrics_options["value"] = element[0];
                alert_conditional_op["label"] = element[1];
                alert_conditional_op["value"] = element[1];
                alert_threshold_val["label"] = element[2];
                alert_threshold_val["value"] = element[2];
                if(bool_condition !== null){
                    alert_join_options["label"] = bool_condition;
                    alert_join_options["value"] = bool_condition;
                    finalDict["alert_join_options"] = alert_join_options;
                    bool_condition=null;
                }
                finalDict["alert_metrics_options"] = alert_metrics_options;
                finalDict["alert_conditional_op"] = alert_conditional_op;
                finalDict["alert_threshold_val"] = alert_threshold_val;
                expressions.push(finalDict);
            }
        });
        return expressions;

    }

    addExpression = (e) => {
        let tempExpression = Object.assign({}, expressionData);
        let expression = this.state.expressions.at(-1)
        this.setState({errorMsg:false});
        if(expression !== undefined && ([expression.alert_conditional_op,expression.alert_threshold_val,expression.alert_metrics_options].includes("")
                                        || (this.state.expressions.length > 1 && [expression.alert_join_options].includes(""))))
        {   
            this.setState({errorMsg:true});
            this.setState((prevState) => ({
                expressions: [...prevState.expressions]
            }));
            
        }
        else
        {
        this.setState((prevState) => ({
            expressions: [...prevState.expressions, tempExpression]
        }));
        }
        }

    removeExpression = (idx) => {
        if (this.state.expressions !== undefined)
        {   this.state.expressions.splice(idx,1)
            this.setState({expressions:this.state.expressions});
        }
    }
    
    dropDownChange= (idx, name, selectedOption) => {
        if (["alert_metrics_options", "alert_conditional_op", "alert_threshold_val", "alert_join_options"].includes(name)) {
            let expressions = [...this.state.expressions];
            expressions[idx][name] = selectedOption;
            this.setState({expressions});
        }
    }

    getAllOptions() {
        let notificationArr = [];
        let pipelineArr = [];
        if(this.state.notificationOptions !== null) {
           notificationArr = this.state.notificationOptions.map(function (row){
                return {"label":row["consume_group_name"]+"["+row["consume_group_type"]+"]", "value":"nid_"+row["consume_group_id"], "type":row["consume_group_type"]};
           });
        }
        if(this.state.pipelineOptions !== null) {
           pipelineArr = this.state.pipelineOptions.map(function (row){
                return {"label":row["pipeline_trigger_name"]+"["+row["pipeline_trigger_type"]+"]", "value":"pid_"+row["pipeline_trigger_id"], "type":row["pipeline_trigger_type"]};
           });
        }
        let final = [...notificationArr, ...pipelineArr];
        return final;

    }

    getDatasets(dataSource, model) {
        let option_arr = [];

        if (dataSource !== null && dataSource !== undefined) {
            let id = dataSource.value;
            if (this.props.details.data_set !== undefined && this.props.details.data_set !== null && this.props.datasets !== null) {
                this.props.details.data_set.map(function (row) {
                if (row["integration_id"] === id) {
                    let req_dataset_name = normalizeChildDatasetName(row["data_set_name"])
                    option_arr.push({"label": req_dataset_name, "value": row["data_set_id"]});
                }
                return 1;
            });
            }
        }else if(model !== null && model !== undefined) {
              option_arr = model.datasets.filter(item => item.value !== "-1")
        }
        return option_arr;
    }

    parseMetaMapping(env_id, data_source_id, data_set_id, attribute_id) {
        // let metaMapping = _.cloneDeep(this.props.dataModule.metaData);
        let metaMapping = this.props.dataModule.metaData;
        let sub_string = `${env_id}.${data_source_id}.${data_set_id}.${attribute_id}`;
        // const filtered = Object.keys(metaMapping)
        //     .filter(key => key.includes(sub_string))
        //     .reduce((obj, key) => {
        //         obj[key] = metaMapping[key];
        //         return obj;
        //     }, {});
        let attributeName = metaMapping[sub_string];
        if (attributeName !== undefined && attributeName !== null) {
            return attributeNameFromMappedValue(attributeName)
        }
        return null;
    }

    getAttributes(data_source, data_set) {
        let data_set_id = null;
        if(data_set !== null) {
          data_set_id = data_set.value;
        }
        let option_arr = [];

       let data_source_id = null;
       let env_id = null;
       let envDSMapping = this.props.dataModule.environmentDataSourceMapping;
       if(data_source !== null &&  envDSMapping !== undefined){
            data_source_id = data_source.value;

            for (const [key, value] of Object.entries(envDSMapping)) {
                if (value.includes(data_source_id.toString())) {
                    env_id = key;
                }
            }
       }

       if (this.props.dataModule.dataSetAttributeMapping !== undefined && data_set_id !== null && data_source_id !== null) {
            let attributes = this.props.dataModule.dataSetAttributeMapping[data_set_id];
            if (attributes !== undefined){
            attributes.forEach((attributeId) => {
                let attribute_name = this.parseMetaMapping(env_id, data_source_id, data_set_id, attributeId)
                let req_attribute_name = normalizeAttributeName(attribute_name)
                option_arr.push({"value": attribute_name, "label": req_attribute_name});
            })
            }
        }
        return option_arr;
    }

    getMetrics(dataSet, dataSource, alerts) {
        let option_arr = [];
        let cm_arr = [];
        let conformityList = [];
        let attributeDict = {};
        let attributeType = null
        let data = null;
        let alertLevel = null;
        let cm_data = null;
        let metadataDetails = this.props.dataModule.metadataDetails;
        let metadataMapping = metadataDetails.metadata_mapping;
        let cm_details = metadataDetails.consistency_metrics_details;
        data = (this.props.tab === "dq" ? this.props.details.dqMetrics : this.props.details.mlMetrics);
        let tab = this.props.tab;
        let attribute = this.state.attribute;
        if(data !== null && dataSet != null) {
            let data_source_id = "";
            if (dataSource !== null) {
                data_source_id = dataSource.value.toString();
            }
            
            let data_set_id = dataSet.value.toString();
            let data_set_type = dataSet.type;
            if (metadataMapping !== undefined && metadataMapping !== null) {
                if (Object.keys(metadataMapping).includes(data_source_id)) {
                    if (Object.keys(metadataMapping[data_source_id]).includes(data_set_id)) {
                        let temp_data = metadataMapping[data_source_id][data_set_id]
                        if (cm_details !== undefined) {
                            cm_data = cm_details[data_set_id]
                        }
                        for(let l in temp_data){
                            let attributeName = temp_data[l]["attribute_name"]
                            if (temp_data[l]["business_rule"] !== null){
                                conformityList.push(CONFORMITY_METRICS_CUSTOM_ALERTS[temp_data[l]["business_rule"]])
                            }
                            if (attribute !== null && attribute["value"] === attributeName) {
                                attributeType = temp_data[l]["attribute_type"]
                                attributeDict[CONFORMITY_METRICS_CUSTOM_ALERTS[temp_data[l]["business_rule"]]] = attributeName
                            }
                        }
                    }
                }
            }

            for(let i=0;i<data.length;i++) {
                let metric_data =  data[i]["metrics"];
                let alertComputeType = alerts["alertComputeType"]["value"]
                if (alertComputeType === "metric_value" || alertComputeType === "drift_value"){
                    alertLevel = "dataset_level"
                }
                else {
                    if (attributeType === "string") {
                        alertLevel = "attribute_level_str"   
                    }
                    else {
                        alertLevel = "attribute_level_num"
                    }
                }
                if( tab === "dq") {
                    for(let j=0; j< metric_data.length; j++) {
                        let d = metric_data[j];
                        if (d["metric_type"] !== "UDF" ){
                            let allowed_metric = DQ_ALERT_ALLOWED_METRICS[alertLevel];
                            if(d["data_set_id"] === null && d["metrics_definition"]["is_template"] === true)
                            {
                                continue;
                            }
                            if (IS_NONE_CHECK.includes(allowed_metric)) {
                                continue;
                            }
                            if (conformityList.length !== 0 && alertLevel === "dataset_level"
                            && conformityList.includes(d["metric_name"])){
                                option_arr.push({"label":d["metric_name"], "value":d["metric_name"], "is_udfm": false});
                            }
                            if (attribute !== null && conformityList.length !== 0 && alertLevel !== "dataset_level"
                            && Object.keys(attributeDict).includes(d["metric_name"])){
                                option_arr.push({"label":d["metric_name"], "value":d["metric_name"], "is_udfm": false});
                            }
                            if (allowed_metric.includes(d["metric_name"])){
                                option_arr.push({"label":d["metric_name"], "value":d["metric_name"], "is_udfm": false});
                            }
                            if (attribute === null && cm_details !== undefined && cm_data !== undefined && cm_data !== null 
                                && cm_data.includes(d["metric_name"])){
                                if (cm_arr.includes(d["metric_name"]) === false){
                                    cm_arr.push(d["metric_name"])
                                    option_arr.push({"label":d["metric_name"], "value":d["metric_name"], "is_udfm": false});
                                }
                            }
                        } else {
                            if (d["data_set_id"] === undefined || d["data_set_id"] === null || data_set_id === undefined || data_set_id === null) {
                                continue;
                            } else if(attribute === null && d["metric_type"] === "UDF" && d["data_set_id"].toString() === data_set_id.toString()) {
                                // we will not show udf metrics, if user selects attribute
                                option_arr.push({"label":d["metric_name"], "value":d["metric_name"], "is_udfm": true});
                            }
                        }
                    }
                }
                else {
                    for(let j=0; j< metric_data.length; j++) {
                        let d = metric_data[j];
                        if (d["metric_type"] !== "UDF" && data_set_type !== null){
                        let allowed_metric = MODEL_ALERT_ALLOWED_METRICS[data_set_type];
                            if (IS_NONE_CHECK.includes(allowed_metric)) {
                                continue;
                            }
                            if (allowed_metric.includes(d["metric_name"])){
                            option_arr.push({"label":d["metric_name"], "value":d["metric_name"], "is_udfm": false});
                            }
                        } else {
                            if (d["data_set_id"] === undefined || d["data_set_id"] === null || data_set_id === undefined || data_set_id === null) {
                                continue;
                            } else if(d["metric_type"] === "UDF" && d["data_set_id"].toString() === data_set_id.toString()) {
                                option_arr.push({"label":d["metric_name"], "value":d["metric_name"], "is_udfm": true});
                            }
                        }
                    }
                }
            }
        }
        return option_arr;
    }

    handleChange = (selectedOptions) => {
        this.setState({ selectedOptions });
    }

    handleClick = e => {
        this.setState({alertType:e.target.value});
    }

    handleConvert = (e) => {
        let tempExpression = Object.assign({}, expressionData);
        this.setState((prevState) => ({
            options: [...prevState.options, tempExpression]
        }));
    }

    disableButton() {
        this.setState({hideSubmitButton: true});
    }

    enableButton() {
        this.setState({hideSubmitButton: false});
    }

    getAssociations() {
        let option_arr = [];
        let data = null;
        data = (this.props.tab === "dq" ? this.props.details.dqMetrics : this.props.details.mlMetrics);
        if (data !== null) {
            option_arr = data.map(function (row){
                            return {"label":row["mas_name"], "value":row["mas_id"]}
                        });
        }
        return option_arr;
    }

    handleStateChange = (selectedOptions) => {
        this.setState({ selectedOptions });
    }

    EnableRecurringTimeInterval(){
        if (this.state.alertType === "recurring") {
            return(
                <div className="form-group row" key={this.state.alertPeriodWithKey}>
                        <label className="col-md-4 col-form-label text-right">Alert Period :</label>
                        <div className="col-md-5">
                            <div className="custom-control custom-radio custom-control-inline pt-2">
                                <input type="radio" name="alertPeriod"
                                       id={this.props.exDetails !== undefined ? "1HourRecurringRadioEx" : "1HourRecurringRadio"}
                                       value="1hour"
                                       onClick={(e) => this.alertPeriodHandler("1hour")}
                                       defaultChecked={this.state.alertPeriod === triggers.HOUR_SCHEDULE}
                                       className="custom-control-input"/>
                                <label className="custom-control-label" htmlFor={this.props.exDetails !== undefined ? "1HourRecurringRadioEx" : "1HourRecurringRadio"}>
                                Once every hour
                                </label>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline pt-2">
                                <input type="radio" name="alertPeriod"
                                       id={this.props.exDetails !== undefined ? "24HourRecurringRadioEx":"24HourRecurringRadio"}
                                       value="24hours"
                                       onClick={(e) => this.alertPeriodHandler("24hours")}
                                       defaultChecked={this.state.alertPeriod === triggers.DAY_SCHEDULE}
                                       className="custom-control-input"/>
                                <label className="custom-control-label" htmlFor={this.props.exDetails !== undefined ? "24HourRecurringRadioEx":"24HourRecurringRadio"}>
                                Once every 24 hours
                                </label>
                            </div>
                        </div>
                    </div>
            );

        }
    }

    radioHandler = (status) => {
        this.setState({alertType: status});
    }

    alertPeriodHandler = (status) => {
        this.setState({alertPeriod: status});
    }

    getComputationTypes(){
        //alertComputeType
        let alertComputationTypes = [{"label":"Metric Value at dataset Level", "value":"metric_value"},
                                      {"label":"Metric Value at Attribute Level", "value":"metric_attribute_level"},
                                      {"label":"Drift Value at dataset Level", "value":"drift_value"},
                                      {"label":"Drift Value at Attribute Level", "value":"drift_attribute_level"}];
        return alertComputationTypes;
    }

    render() {
        // For Recency we allow user can able to configure one alert condition only.
        let canShowAddCondition = true;
        if ((this.state.expressions).length === 1) {
            let currentExp = this.state.expressions[0];
            if (currentExp.alert_metrics_options !== undefined && currentExp.alert_metrics_options !== null) {
                if (currentExp.alert_metrics_options.value === "Recency" && currentExp.alert_conditional_op !== ""
                && currentExp.alert_threshold_val !== "") {
                    canShowAddCondition = false;
                }
            }
        }

        let metrics_options = this.getMetrics(this.state.dataSet, this.state.dataSource, this.state.alerts);
        // To avoid user to configure any other metrics with recency
        if (this.state.expressions.length > 0 && canShowAddCondition === true) {
            let currentExp = this.state.expressions[0];
            if (currentExp.alert_metrics_options !== undefined && currentExp.alert_metrics_options !== null) {
                if (currentExp.alert_metrics_options.value !== "Recency" && currentExp.alert_conditional_op !== ""
                && currentExp.alert_threshold_val !== "") {
                    let newMetricsList = []
                    for (let k = 0; k < metrics_options.length; k++) {
                        if (metrics_options[k].value !== "Recency") {
                            newMetricsList.push(metrics_options[k]);
                        }
                    }
                    metrics_options = newMetricsList;
                }
            }
        }

        let alert_conditional_op = [{"label":">", "value":">"}, {"label":">=", "value":">="}, {"label":"<", "value":"<"},
            {"label":"<=", "value":"<="}, {"label":"==", "value":"=="}];
        let alert_join_options = [{"label":"AND", "value":"AND"},{"label":"OR", "value":"OR"}]
        let alert_threshold_options = [{"label":"0", "value":0},{"label":"1", "value":1},{"label":"2", "value":2},{"label":"3", "value":3},{"label":"4", "value":4},{"label":"5", "value":5},{"label":"6", "value":6},{"label":"7", "value":7},{"label":"8", "value":8},{"label":"9", "value":9},{"label":"10", "value":10},{"label":"11", "value":11},{"label":"12", "value":12},{"label":"13", "value":13},{"label":"14", "value":14},{"label":"15", "value":15},{"label":"16", "value":16},{"label":"17", "value":17},{"label":"18", "value":18},{"label":"19", "value":19},{"label":"20", "value":20},{"label":"21", "value":21},{"label":"22", "value":22},{"label":"23", "value":23},{"label":"24", "value":24},{"label":"25", "value":25},{"label":"26", "value":26},{"label":"27", "value":27},{"label":"28", "value":28},{"label":"29", "value":29},{"label":"30", "value":30},{"label":"31", "value":31},{"label":"32", "value":32},{"label":"33", "value":33},{"label":"34", "value":34},{"label":"35", "value":35},{"label":"36", "value":36},{"label":"37", "value":37},{"label":"38", "value":38},{"label":"39", "value":39},{"label":"40", "value":40},{"label":"41", "value":41},{"label":"42", "value":42},{"label":"43", "value":43},{"label":"44", "value":44},{"label":"45", "value":45},{"label":"46", "value":46},{"label":"47", "value":47},{"label":"48", "value":48},{"label":"49", "value":49},{"label":"50", "value":50},{"label":"51", "value":51},{"label":"52", "value":52},{"label":"53", "value":53},{"label":"54", "value":54},{"label":"55", "value":55},{"label":"56", "value":56},{"label":"57", "value":57},{"label":"58", "value":58},{"label":"59", "value":59},{"label":"60", "value":60},{"label":"61", "value":61},{"label":"62", "value":62},{"label":"63", "value":63},{"label":"64", "value":64},{"label":"65", "value":65},{"label":"66", "value":66},{"label":"67", "value":67},{"label":"68", "value":68},{"label":"69", "value":69},{"label":"70", "value":70},{"label":"71", "value":71},{"label":"72", "value":72},{"label":"73", "value":73},{"label":"74", "value":74},{"label":"75", "value":75},{"label":"76", "value":76},{"label":"77", "value":77},{"label":"78", "value":78},{"label":"79", "value":79},{"label":"80", "value":80},{"label":"81", "value":81},{"label":"82", "value":82},{"label":"83", "value":83},{"label":"84", "value":84},{"label":"85", "value":85},{"label":"86", "value":86},{"label":"87", "value":87},{"label":"88", "value":88},{"label":"89", "value":89},{"label":"90", "value":90},{"label":"91", "value":91},{"label":"92", "value":92},{"label":"93", "value":93},{"label":"94", "value":94},{"label":"95", "value":95},{"label":"96", "value":96},{"label":"97", "value":97},{"label":"98", "value":98},{"label":"99", "value":99},{"label":"100", "value":100}];
//        let time_interval_options = [{"label": "@once", "value": "@once"}, {"label": "@daily", "value": "@daily"},
//            {"label": "@hourly", "value": "@hourly"}, {"label": "@monthly", "value": "@monthly"}];
        let triggerOptions = this.getAllOptions();
//        let associates_options = this.getAssociations();
        let data_set_options = this.getDatasets(this.state.dataSource, this.state.model);
        let attribute_options = this.getAttributes(this.state.dataSource, this.state.dataSet);
        let alertComputationTypes = this.getComputationTypes();


    /** Sorting Datasource and dataset options for the From dropDown */
        if(data_set_options.length>1){
            data_set_options = sortDict(data_set_options)
        }

        let datasourceOptions = [];
        if(this.props.integrationOption !== undefined && this.props.integrationOption !== null && this.props.integrationOption.length > 1){
            datasourceOptions= sortDict(this.props.integrationOption)
        }
        else{
            datasourceOptions= this.props.integrationOption
        }
    /** Sorting Datasource and dataset options for the Form dropDown */





        let {expressions} = this.state;
//        const selectStyles = {
//            container: () => ({
//                height: 34
//            }),
//            indicatorSeparator: () => ({
//
//            }),
//        };
        let has_attribute = (this.state.alertComputeType !== null && this.state.alertComputeType["value"] !==null && this.state.alertComputeType["value"].includes("attribute_level"));
        let alertSchema = "";
        if(this.props.tab === "dq") {
            alertSchema = yup.object({
                alert_name: yup.string().min(1,"Name must be at least 1 characters").required("Alert Name is a required field").test(
                    'Alert name test',
                    'invalid Alert name',        
                    function test(value) {        
                       let val = userValidation(value,"input");       
                       return val;
                }
                ),
                alertComputeType : yup.string().required("Alert Type is a required field"),
                alertMechanism: yup.string().required('Alert Mechanism is a required field'),
                dataSourceId:  yup.number().required('Datasource is a required field'),
                data_set_id: yup.number().required('Dataset is a required field')
            });
            if (has_attribute === true){
                    alertSchema = yup.object({
                        alert_name: yup.string().min(1,"Name must be at least 1 characters").required("Alert Name is a required field").test(
                            'Alert name test',
                            'invalid Alert name',        
                            function test(value) {        
                                let val = userValidation(value,"input");       
                                return val;
                        }
                        ),
                alertComputeType : yup.string().required("Alert Type is a required field"),
                alertMechanism: yup.string().required('Alert Mechanism is a required field'),
                dataSourceId:  yup.number().required('Datasource is a required field'),
                data_set_id: yup.number().required('Dataset is a required field'),
                attribute_name:  yup.string().required("Attribute Name is a required field"),
                });
            }
        }else {
             alertSchema = yup.object({
                alert_name: yup.string().min(1,"Name must be at least 1 characters").required("Alert Name is a required field").test(
                    'Alert name test',
                    'invalid Alert name',        
                    function test(value) {        
                       let val = userValidation(value,"input");       
                       return val;
                }
                ),
                alertMechanism: yup.string().required('Alert Mechanism is a required field'),
                modelId: yup.number().required('Model is a required field'),
                data_set_id: yup.number().required('Dataset is a required field')
             });

        }

        let exDetails = this.props.exDetails;
        if (this.props.exDetails !== undefined) {
             exDetails["alertMechanism"] = this.state.alerts.mechanismOptions;
        }
        let initial_values = {alert_name: '',dataSourceId: '', modelId: '', data_set_id:'', alertComputeType:'', attribute_name:'', alertMechanism:this.state.alert_mechanism, alertPeriod: '', alert_type: '' , errorMsg:this.state.errorMsg};
        return (
            <div className="row">
                <div className="col-md-10 pt-4">
                <Formik
                        validationSchema={alertSchema}
                        onSubmit={this.alertFormSubmit}
                         initialValues={this.props.exDetails !== undefined ? this.state.alerts : initial_values}
                    >
                    {({
                          values,
                          setFieldValue,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                          isValid,
                    }) => (
                        <Form noValidate name="alert_configure" onSubmit={handleSubmit}>
                            <Form.Group controlId="alert_name" className="row">
                                    <Form.Label className="col-md-5 col-lg-4 col-form-label text-md-right">Alert Name <span className="text-danger">*</span> :</Form.Label>
                                        <div className="col-md-7 col-lg-6">
                                            <Form.Control
                                                type="text"
                                                placeholder="Alert Name"
                                                value={values.alert_name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.alert_name}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                               { errors.alert_name }
                                            </Form.Control.Feedback>
                                        </div>
                            </Form.Group>
                            <Form.Group controlId="alert_type" className="row" key= {this.state.alertTypeWithkey}>
                                <Form.Label className="col-md-5 col-lg-4 col-form-label text-md-right">Types :</Form.Label>
                                                            <div className="col-md-7 col-lg-6">
                                <div className="custom-control custom-radio custom-control-inline pt-2">
                                    <input type="radio" name="alert_type" onClick={(e) => this.radioHandler("instant")}
                                           id={this.props.exDetails !== undefined ? "instantRadioEx" : "instantRadio"}
                                           value="instant"
                                           defaultChecked={this.state.alertType === triggers.INSTANT_NOTIFICATION}
                                           className="custom-control-input"/>
                                    <label className="custom-control-label"
                                           htmlFor={this.props.exDetails !== undefined ? "instantRadioEx" : "instantRadio"}>
                                        Instantly
                                    </label>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline pt-2">
                                    <input type="radio" name="alert_type" onClick={(e) => this.radioHandler("recurring")}
                                           id={this.props.exDetails !== undefined ? "recurringRadioEx" : "recurringRadio"}
                                           value="recurring"
                                           defaultChecked={this.state.alertType === triggers.RECURRING_NOTIFICATION}
                                           className="custom-control-input"/>
                                    <label className="custom-control-label"
                                           htmlFor={this.props.exDetails !== undefined ? "recurringRadioEx" : "recurringRadio"}>
                                        Recurring
                                    </label>
                                </div>
                            </div>
                            </Form.Group>
                            {this.state.alertType === triggers.RECURRING_NOTIFICATION? this.EnableRecurringTimeInterval(): ""}
                            {this.props.tab === "dq" ?
                                  <Form.Group controlId="dataSourceId" className="row">
                                <Form.Label className="col-md-5 col-lg-4 col-form-label text-md-right">Datasource <span className="text-danger">*</span> :</Form.Label>
                                <div className="col-md-7 col-lg-6">
                                   <Select key= {this.state.alertDataSourceWithKey}
                                    name="dataSourceId"
                                    filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="alertDataSource"
                                    options={datasourceOptions}
                                    placeholder="Select Datasource"
                                    isInvalid={errors.dataSourceId && touched.dataSourceId}
                                    onChange={selectedOption => {
                                                handleChange("dataSourceId")(selectedOption.value.toString());
                                                setFieldValue('data_set_id', '')
                                                setFieldValue('attribute_name', '')
                                                let alerts = this.state.alerts;
                                                alerts.dataset = null;
                                                alerts.attribute = null;
                                                this.setState({dataSource: selectedOption, alerts: alerts});
                                              }}
                                    classNamePrefix='select-control'
                                    defaultValue={this.state.dataSource}
                                    />
                                    {this.state.dataSource === null && <ErrorMessage component="div" className="error-text" name="dataSourceId" />}
                                </div>
                            </Form.Group> :
                            <Form.Group controlId="modelId" className="row">
                                <Form.Label className="col-md-5 col-lg-4 col-form-label text-md-right">Model <span className="text-danger">*</span> :</Form.Label>
                                <div className="col-md-7 col-lg-6">
                                   <Select key= {this.state.alertModelWithKey}
                                    name="modelId"
                                    filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="alertModel"
                                    options={this.props.modelOptions}
                                    placeholder="Select Model"
                                    isInvalid={errors.modelId && touched.modelId}
                                    onChange={selectedOption => {
                                                handleChange("modelId")(selectedOption.value.toString());
                                                setFieldValue('data_set_id', '')
                                                let alerts = this.state.alerts;
                                                alerts.dataset = null;
                                                this.setState({model: selectedOption, alerts: alerts});
                                              }}
                                    classNamePrefix='select-control'
                                    defaultValue={this.state.model}
                                    />
                                    {this.state.model === null && <ErrorMessage component="div" className="error-text" name="modelId" /> }
                                </div>
                            </Form.Group>
                            }
                            <Form.Group controlId="data_set_id" className="row">
                                <Form.Label className="col-md-5 col-lg-4 col-form-label text-md-right">Dataset <span className="text-danger">*</span> :</Form.Label>
                                <div className="col-md-7 col-lg-6">
                                   <Select key= {this.state.alertDatasetWithKey}
                                    name="data_set_id"
                                    filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="alertDataset"
                                    options={data_set_options}
                                    placeholder="Select Dataset"
                                    isInvalid={errors.data_set_id && touched.data_set_id}
                                    onChange={selectedOption => {
                                                handleChange("data_set_id")(selectedOption.value.toString());
                                                setFieldValue('attribute_name', '')
                                                let alerts = this.state.alerts;
                                                alerts.attribute = null;
                                                alerts.dataset = selectedOption;
                                                this.setState({dataSet:selectedOption, alerts: alerts, expressions:[]})
                                              }}
                                    classNamePrefix='select-control'
                                    value={this.state.alerts.dataset}
                                    />
                                    {this.state.alerts.dataset === null && <ErrorMessage component="div" className="error-text" name="data_set_id" /> }
                                </div>
                            </Form.Group>
                            {
                            this.props.tab === "dq" &&
                                <Form.Group controlId="alertComputeType" className="row">
                                    <Form.Label className="col-md-5 col-lg-4 col-form-label text-md-right">Alert On <span className="text-danger">*</span> :</Form.Label>
                                    <div className="col-md-7 col-lg-5">
                                       <Select key= {this.state.alertComputeType}
                                        name="alertComputeType"
                                        filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                        id="alertComputeType"
                                        options={alertComputationTypes}
                                        placeholder="Select Alert Type"
                                        isInvalid={errors.alertComputeType && touched.alertComputeType}
                                        onChange={selectedOption => {
                                                    handleChange("alertComputeType")(selectedOption.value.toString());
                                                    setFieldValue('expressions', '')
                                                    setFieldValue('attribute_name', '')
                                                    let alerts = this.state.alerts;
                                                    alerts.attribute = null;
                                                    alerts.alertComputeType = selectedOption;
                                                    this.setState({alertComputeType:selectedOption, alerts: alerts});
                                                  }}
                                        classNamePrefix='select-control'
                                        value={this.state.alerts.alertComputeType}
                                        />
                                        {this.state.alerts.alertComputeType === null && <ErrorMessage component="div" className="error-text" name="alertComputeType" /> }
                                    </div>
                                </Form.Group>
                            }
                            {
                            (this.props.tab === "dq" && has_attribute === true) ?
                            <Form.Group controlId="attribute_name" className="row">
                                <Form.Label className="col-md-5 col-lg-4 col-form-label text-md-right">Attribute <span className="text-danger">*</span> :</Form.Label>
                                <div className="col-md-7 col-lg-5">
                                   <Select key= {this.state.alertAttributeWithKey}
                                    name="attribute_name"
                                    filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="alertAttribute"
                                    options={attribute_options}
                                    placeholder="Select Attribute"
                                    isInvalid={errors.attribute_name && touched.attribute_name}
                                    onChange={selectedOption => {
                                                handleChange("attribute_name")(selectedOption.value.toString());
                                                setFieldValue('expressions', '')
                                                let alerts = this.state.alerts;
                                                alerts.attribute = selectedOption;
                                                this.setState({attribute:selectedOption, alerts: alerts, expressions:[]});
                                              }}
                                    classNamePrefix='select-control'
                                    value={this.state.alerts.attribute}
                                    />
                                    <ErrorMessage component="div" className="error-text" name="attribute_name" />
                                </div>
                            </Form.Group> : ''
                            }
                            <Form.Group controlId="expressions" className="row">
                                 <Form.Label className="col-md-5 col-lg-4 col-form-label text-md-right">Alert If <span className="text-danger">*</span> :</Form.Label>
                                 <div className="col-md-7 col-lg-6">
                                     <Expressions   expressions={expressions} 
                                                    dropDownChange={this.dropDownChange} 
                                                    metrics_options={metrics_options}
                                                    alert_conditional_op={alert_conditional_op}  
                                                    alert_threshold_options={alert_threshold_options }
                                                    alert_join_options={alert_join_options}
                                                    removeExpression={this.removeExpression} 
                                                    errorMsg = {this.state.errorMsg}/>
                                                    {canShowAddCondition === true ?
                                         <button type="button"  onClick={this.addExpression} className="btn btn-outline-primary px-3">
                                            <FontAwesomeIcon icon={faPlusSquare}/> Add Condition
                                        </button>: ""}
                                 </div>
                            </Form.Group>
                            <Form.Group controlId="alertMechanism" className="row">
                                <Form.Label className="col-md-5 col-lg-4 col-form-label text-md-right">Alert Mechanism <span className="text-danger">*</span> :</Form.Label>
                                    <div className="col-md-7 col-lg-6">
                                        <Select key= {this.state.alertMechanismWithKey}
                                            isMulti
                                            name="alertMechanism"
                                            filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                            id="alertMechanism"
                                            options={triggerOptions}
                                            onChange={selectedOption => {
                                                if (selectedOption !==null && selectedOption.length > 0) {
                                                    handleChange("alertMechanism")(selectedOption[0].value.toString());
                                                    this.handleStateChange(selectedOption);
                                                } else {
                                                    handleChange("alertMechanism")("");
                                                }
                                              }}
                                            isInvalid={errors.alertMechanism && touched.alertMechanism}
                                            defaultValue={this.state.alerts.mechanismOptions}
                                            placeholder="Select Alert Mechanism"
                                        />
                                        <ErrorMessage component="div" className="error-text"  name="alertMechanism" />
                                    </div>
                            </Form.Group>
                       <div className="form-group row">
                            <div className="col-md-5 offset-sm-5 offset-lg-4">
                            <button type="button" onClick={() => this.props.exDetails ? this.props.closeModal() : this.props.handleClick()} className="btn btn-outline btn-grey btn-circle mr-2">Cancel</button>
                                <button type="submit" disabled={this.state.hideSubmitButton} className="btn btn-primary btn-circle">
                                    <FontAwesomeIcon icon={faCheck}/>Submit
                                </button>
                            </div>
                       </div>
                </Form>
               )}
               </Formik>

                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return state;
}

export default connect(mapStateToProps,storeMetadataDetails) (AlertForm);